var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseOfPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M25.6 22.4C18 20.2 18 28.1 22.8 28c4.7-.1 5.3 7.5-3.1 5.2M22.6 20.7v.7M22.6 34.3v.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 32.9,
    cy: 40.8,
    r: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M33 35.4V17.2h6.8L22.7 2.1 5.8 17.5h7v23.3H28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseOfPrice);
export default __webpack_public_path__ + "static/media/increaseOfPrice.54953e2f125ed3b6abc9428245828ff5.svg";
export { ForwardRef as ReactComponent };